// Sadly, there are no modern type definitions for NanoEvents 2. :(
// @ts-ignore
import NanoEvents from 'nanoevents';

let scrollEventBound = false;
let allowPublish = true;


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scrollEmitter = new NanoEvents<any>();

export interface IScrollPosition {
    x: number;
    y: number;
}


export const getScrollPosition = (): IScrollPosition => ({
    x: window.pageXOffset || document.documentElement.scrollLeft,
    y: window.pageYOffset || document.documentElement.scrollTop,
});


const bindGlobalScrollEvent = (): void => {
    if (!scrollEventBound) {
        window.addEventListener("scroll", (): void => {
            if (allowPublish) {
                scrollEmitter.emit("scroll", getScrollPosition());
            }
        });

        scrollEventBound = true;
    }
};



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onScroll = (funcRef: (props: IScrollPosition) => any): () => void => {
    bindGlobalScrollEvent();
    return scrollEmitter.on("scroll", funcRef);
};


export const disableScrollCallback = (): void => {
    allowPublish = false;
};

export const enableScrollCallback = (): void => {
    allowPublish = true;
};

